/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table8({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        bgStart: false,
        bgEnd: false,
        id: uuidV4(),
        stt: 1,
        value2: "Doanh thu tính thuế thu nhập doanh nghiệp",
        value3: "[10]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: 2,
        value2: "Chi phí tính thuế thu nhập doanh nghiệp",
        value3: "[11]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: 3,
        value2: "Thu nhập miễn thuế",
        value3: "[12]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: 4,
        value2: "Chuyễn lỗ và bù trừ lãi/ lỗ",
        value3: "[13]",
        value4: 0,
      },
      {
        bgStart: true,
        bgEnd: false,
        bold: false,
        bg: true,
        id: uuidV4(),
        stt: 5,
        value2: "Thu nhập tính thuế ([14]=[10]-[11]-[12]-[13]",
        value3: "[14]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: 6,
        value2: "Thuế thu nhập doanh nghiệp phải nộp",
        value3: "[15]",
        value4: 0,
      },
      {
        bgStart: true,
        bgEnd: true,
        bold: true,
        id: uuidV4(),
        stt: 7,
        value2: "Xác định số thuế thu nhập doanh nghiệp được   giảm trong kỳ tính thuế ([16]=[18]+[20]) (Không quá số thuế thu nhập doanh nghiệp phải nộp)",
        value3: "[16]",
        value4: 0,
      },
      {
        bgStart: true,
        bgEnd: true,
        bold: false,
        id: uuidV4(),
        stt: "7.1",
        value2: "Giảm thuế thu nhập doanh nghiệp tương ứng mức chi cho lao động nữ",
        value3: "",
        value4: "",
      },
      {
        bgStart: false,
        bgEnd: true,
        bold: false,
        id: uuidV4(),
        stt: "-",
        value2: "Tổng các khoản chi cho lao động nữ",
        value3: "[17]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: "-",
        value2: "Thuế thu nhập doanh nghiệp được giảm",
        value3: "[18]",
        value4: 0,
      },
      {
        bgStart: true,
        bgEnd: true,
        bold: false,
        id: uuidV4(),
        stt: "7.2",
        value2: "Giảm thuế thu nhập doanh nghiệp tương ứng mức chi cho lao động là người dân tộc thiểu số",
        value3: "",
        value4: "",
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: "-",
        value2: "Tổng các khoản chi cho lao động là người dân tộc thiểu số",
        value3: "[19]",
        value4: 0,
      },
      {
        bgStart: false,
        bgEnd: false,
        bold: false,
        id: uuidV4(),
        stt: "-",
        value2: "Thuế thu nhập doanh nghiệp được giảm",
        value3: "[20]",
        value4: 0,
      },
    ],
    muc2: [
      {
        bg: true,
        id: uuidV4(),
        value2: "Thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế TNDN ([21]=[15]-[16])",
        value3: "[21]",
        value4: 0,
      },
      {
        bg: false,
        id: uuidV4(),
        value2: "Thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này",
        value3: "[22]",
        value4: 0,
      },
      {
        bg: false,
        id: uuidV4(),
        value2: "Thuế TNDN đã tạm nộp trong năm",
        value3: "[23]",
        value4: 0,
      },
      {
        bg: true,
        id: uuidV4(),
        value2: "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm ([24]=[21]-[23])",
        value3: "[24]",
        value4: 0,
      },
      {
        bg: true,
        id: uuidV4(),
        value2: "Thuế TNDN còn phải nộp ([25]=[21]-[22]-[23]",
        value3: "[25]",
        value4: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: 0,
      value11: "",
      value12: 0,
      value13: "",
      value14: 0,
      value15: 0,
      value16: 0,
      value17: 0,
      value18: 0,
      value19: 0,
      value20: 0,
      value21: 0,
      value22: 0,
      value23: "",
      value24: 0,
      value25: 0,
      value26: 0,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <Typography variant="h4" textTransform="uppercase">
          B. Xác định ưu đãi thuế thu nhập doanh nghiệp của người nộp thuế tại trụ sở chính, đơn vị
          phụ thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
        <table style={tableStyle}>
        <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (3)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (4)
              </Th>
            </tr>
          </thead>
          <tbody>
          {data.muc1.map((item, index) => (
              <tr key={index} style={{}}>
                <Td style={{ textAlign: "center", background: item.bgStart ? "#ddeff3" : "transparent", fontWeight: item.bold ? "bold" : "normal" }}>
                 {item.stt}
                </Td>
                <Td style={{ textAlign: "left", background: item.bgStart ? "#ddeff3" : "transparent", fontWeight: item.bold ? "bold" : "normal" }}>
                {item.value2}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold",background: item.bgStart ? "#ddeff3" : "transparent", fontWeight: "bold"}}>
                {item.value3}
                </Td>
                <Td style={{ textAlign: "right",background: item.bgEnd ? "#ddeff3" : "transparent", fontWeight: item.bold ? "bold" : "normal"}}>
                  {
                    item.bgEnd ? item.value4 : <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                  }
                
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h4" textTransform="uppercase">
          C. Xác định số thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế  TNDN của đơn vị phụ thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
          {data.muc2.map((item, index) => (
              <tr key={index} style={{}}>
                <Td style={{ textAlign: "center", background: item.bg ? "#ddeff3" : "transparent" }}>
                  {index + 1}
                </Td>
                <Td style={{ textAlign: "left", background: item.bg ? "#ddeff3" : "transparent" }}>
                {item.value2}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold",background: item.bg ? "#ddeff3" : "transparent"}}>
                {item.value3}
                </Td>
                <Td style={{ textAlign: "right",background: "#ddeff3"}}>
                {item.value4}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
    </Box>
  );
}

export default memo(Table8);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: "100%",
        minWidth: "70px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
